<template>
  <div v-if="(dataComplate.profile < 6 || dataComplate.asessment < count_asessment) && user.roles != 'ADMIN' && showByRoute">
    <b-alert show variant="danger" >
      <h4 class="alert-heading">{{ $t('penting') }}</h4>
      <p>{{ $t('deskripsi_notif') }}</p>
      <p style="font-weight:bold">Due Date Assessment : {{ due_date }}</p>
     
    </b-alert>
  </div>
</template>
<script>
  import { mapActions, mapState } from 'vuex';
  import { getAsessment } from '../../_services/asessment.service';
  export default {
    name: 'Sidebar',
    data(){
      return {
        user : '',
        count_asessment : 0,
        showByRoute: true,
        due_date : localStorage.getItem('due_date')
      }
    },
    async mounted(){
      if (this.$route.path != '/dashboard/candidate') {
        this.showByRoute = false;
      }
      this.getDataComplate();
      this.user = JSON.parse(localStorage.getItem('user'));
      let c_asess = localStorage.getItem('count_asessment');
      if (!c_asess) {
        let data = await getAsessment();
        localStorage.setItem('count_asessment', data.data.length);
        this.count_asessment = data.data.length;
      }else{
        this.count_asessment = c_asess;
      }
    },
    computed: {
      ...mapState({
        dataComplate: (state) => state.notification.notification,
      }),
    },
    methods: {
      ...mapActions("notification", ["getDataComplate"]),
      toggle_sidebar() {
        this.$store.dispatch('menu/opensidebar');
        this.$store.state.menu.activeoverlay = false;
      },
    },
  };
</script>
